import JsBarcode from 'jsbarcode';

export default {
  name: 'ExuBarcode',
  methods: {
    // @elementID {string} - ID элемента в который будет выведен штрихкод, svg, canvas, img.
    // @barcode {string} - Значение закодированное в штрихкод.
    createBarcode(elmentID, barcode) {
      JsBarcode(`#${elmentID}`, barcode, {
        format: 'ean13',
        width: 3,
        height: 80,
        // Штрихкод сканируют с экрана, поэтому чёрный, а не палитровый графит:
        // читалке нужен максимальный контраст со светлой подложкой.
        lineColor: '#000000',
        fontSize: 10,
        textMargin: -5,
        margin: 5,
        displayValue: false,
      });
      document.getElementById(elmentID).removeAttribute('width');
      document.getElementById(elmentID).removeAttribute('height');
    },
  },
};
